import type { ITemplateCard } from '@/models/interfaces'
import { DateTime } from 'luxon'
import type {
  Card as CardModel,
  Field as FieldModel,
  Tab as TabModel
} from './library.types'
import { LibraryFieldType } from './library.enums'

const EMPTY_CREATED_AT = DateTime.fromMillis(0)

export const Tab: TabModel = {
  itemId: 0,
  name: '',
  userId: 0,
  caseId: 0,
  createdWhen: EMPTY_CREATED_AT,
  cardCount: 0
}

export const Card: CardModel = {
  itemId: 0,
  tabId: 0,
  tabName: '',
  shared: false,
  title: '',
  description: '',
  fields: [],
  userId: 0,
  createdWhen: EMPTY_CREATED_AT
}

export const Field: FieldModel = {
  itemId: 0,
  cardId: 0,
  content: '',
  type: LibraryFieldType.Name
}

export const EmptyCard: ITemplateCard = {
  templateName: 'infoLibrary.templates[0].templateName',
  templateDescription: 'infoLibrary.templates[0].templateDescription',
  description: 'infoLibrary.templates[0].description',
  nameField: 'infoLibrary.templates[0].nameField',
  phoneField: 'infoLibrary.templates[0].phoneField',
  emailField: 'infoLibrary.templates[0].emailField',
  addressField: 'infoLibrary.templates[0].addressField',
  cityField: 'infoLibrary.templates[0].cityField',
  stateField: 'infoLibrary.templates[0].stateField',
  zipField: 'infoLibrary.templates[0].zipField'
}

export const NameField = { ...Field, type: LibraryFieldType.Name }

export const PhoneField = { ...Field, type: LibraryFieldType.PhoneNumber }

export const EmailField = { ...Field, type: LibraryFieldType.EmailAddress }

export const AddressField = { ...Field, type: LibraryFieldType.Address }

export const CityField = { ...Field, type: LibraryFieldType.AddressCity }

export const StateField = { ...Field, type: LibraryFieldType.AddressState }

export const ZipField = { ...Field, type: LibraryFieldType.AddressZip }

export const BASE_URL = '/web/api/infolibrary'
export const MOBILE_BASE_URL = BASE_URL

// Cache configuration - mirroring journal.constants.ts pattern
export const LIBRARY_CACHE_MAX_AGE_SECONDS_DEV = 1 * 60 // 1 minute for development
export const LIBRARY_CACHE_MAX_AGE_SECONDS_PROD = 5 * 60 // 5 minutes for production

export const LIBRARY_CACHE_MAX_AGE_SECONDS =
  import.meta.env?.MODE === 'production'
    ? LIBRARY_CACHE_MAX_AGE_SECONDS_PROD
    : LIBRARY_CACHE_MAX_AGE_SECONDS_DEV

export const TABS_NAMESPACE = 'library_tabs'
export const CARDS_NAMESPACE = 'library_cards'
export const CARD_NAMESPACE = 'library_card'
